import React, {useEffect} from 'react';
import Countdown, {CountdownRenderProps} from 'react-countdown';
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

interface HomePageCountdownProps {
    showCountdown: boolean;
    setShowCountdown: (show: boolean) => void;
}

const HomePageCountdown = ({showCountdown, setShowCountdown}: HomePageCountdownProps) => {

    const [clicked, setClicked] = React.useState<number>(0);

    const targetDate = new Date('2025-08-26T18:30');

    useEffect(() => {
        if (new Date() > targetDate) {
            setShowCountdown(false);
        }
    }, [targetDate]);

    useEffect(() => {
        if (clicked > 14) {
            setShowCountdown(false);
            localStorage.setItem('disableCountdown', 'true');
        }
    }, [clicked]);

    const renderer = ({days, hours, minutes, seconds, completed}: CountdownRenderProps) => {
        if (completed) {
            // When the countdown is completed, set showCountdown to false to hide it.
            setShowCountdown(false);
            return null; // Don't render anything when completed
        } else {
            // Render the countdown display
            return (
                <div style={{
                    top: 0,
                    left: 0,
                    position: "fixed",
                    height: '100vh',
                    width: '100%',
                    fontSize: '2em',
                    textAlign: 'center',
                    backgroundColor: '#543B26',
                    alignContent: 'center',
                    padding: '8px'
                }}>

                    <Box
                        component="img"
                        sx={{ width: { xs: 200, sm: 250 }, mb: 8}}
                        src={'/looty-logo.png'}
                        alt="looty logo"
                        onClick={() => setClicked(clicked + 1)}
                    />

                    <Typography
                        variant={"fourthVariant"}
                    >
                        Looty arrive dans:
                    </Typography>
                    <Typography
                        lineHeight={2}
                        mt={1}
                        variant={"fourthVariant"}
                    >
                        <span>{days} jours </span>
                        <span>{hours} heures </span>
                        <span>{minutes} minutes </span>
                        <span>{seconds} secondes</span>
                    </Typography>
                </div>
            );
        }
    };

    return (
        <div>
            {/* Conditionally render the Countdown component based on showCountdown state */}
            {showCountdown && (
                <Countdown date={targetDate} renderer={renderer}/>
            )}

            {/* This content will be revealed after the countdown disappears */}
            {!showCountdown && (
                <div style={{
                    fontSize: '1.5em',
                    textAlign: 'center',
                    marginTop: '50px',
                    color: '#555'
                }}>
                    Welcome to our website! We're now live!
                    {/* Your main website content goes here */}
                </div>
            )}
        </div>
    );
};

export default HomePageCountdown;
